/* Keep the ROI planner handoff in sync with the product variant the shopper
 * actually selects. The Liquid-rendered href remains a useful no-JS fallback. */
(() => {
  const CARD_SELECTOR = '[data-alamo-roi-card]';

  const trackingPayload = (card, variant = null) => ({
    roi_model: card.dataset.roiModel || '',
    roi_service: card.dataset.roiService || '',
    product_id: card.dataset.roiProductId || '',
    product_handle: card.dataset.roiProductHandle || '',
    variant_id: variant?.id || card.dataset.roiSelectedVariantId || card.dataset.roiInitialVariantId || '',
    listed_price: variant ? Number(variant.price) / 100 : undefined,
    product_available: variant ? Boolean(variant.available) : undefined,
    surface: 'product_card',
  });

  const track = (eventName, card, variant = null) => {
    try { window.AlamoRoiTracking?.track(eventName, trackingPayload(card, variant)); } catch (_error) {}
  };

  const parseVariants = (card) => {
    const source = card.nextElementSibling;
    if (!source || !source.matches('script[data-alamo-roi-variants]')) return [];

    try {
      const variants = JSON.parse(source.textContent || '[]');
      return Array.isArray(variants) ? variants : [];
    } catch (_error) {
      return [];
    }
  };

  const selectedVariantId = (card) => {
    const scope = card.closest('.product-info') || card.closest('[data-section-id]') || document;
    const selectedOption = scope.querySelector('[data-variant-id]:checked');
    if (selectedOption?.dataset.variantId) return selectedOption.dataset.variantId;

    const variantInput = scope.querySelector('input[name="id"], select[name="id"]');
    if (variantInput?.value) return variantInput.value;

    return card.dataset.roiInitialVariantId || '';
  };

  const schedule = (callback) => {
    window.requestAnimationFrame(() => window.requestAnimationFrame(callback));
  };

  const syncCard = (card, variants) => {
    const variantId = String(selectedVariantId(card));
    const variant = variants.find((item) => String(item.id) === variantId);
    if (!variant) return;

    const priceCents = Number(variant.price);
    if (!Number.isFinite(priceCents)) return;

    const planner = new URL(card.dataset.roiRoute || '/pages/equipment-roi-calculator', window.location.origin);
    const returnUrl = new URL(card.dataset.roiProductUrl || '/', window.location.origin);
    returnUrl.searchParams.set('variant', variant.id);

    planner.searchParams.set('equipment', card.dataset.roiEquipment || 'Your equipment');
    planner.searchParams.set('price', (priceCents / 100).toFixed(2));
    planner.searchParams.set('roi_model', card.dataset.roiModel || '');
    planner.searchParams.set('product_url', `${returnUrl.pathname}${returnUrl.search}${returnUrl.hash}`);
    if (card.dataset.roiProductId) planner.searchParams.set('product_id', card.dataset.roiProductId);
    if (card.dataset.roiProductHandle) planner.searchParams.set('product_handle', card.dataset.roiProductHandle);
    planner.searchParams.set('variant_id', String(variant.id));
    planner.searchParams.set('product_purchase', String(Boolean(variant.available && priceCents > 0)));

    if (card.dataset.roiProductImage) planner.searchParams.set('product_image', card.dataset.roiProductImage);
    if (card.dataset.roiService) planner.searchParams.set('roi_service', card.dataset.roiService);

    const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id') || card.dataset.roiPreviewThemeId;
    if (previewThemeId) planner.searchParams.set('preview_theme_id', previewThemeId);

    card.href = planner.toString();
    card.dataset.roiSelectedVariantId = String(variant.id);
  };

  const bindCard = (card) => {
    if (card.dataset.roiVariantSyncBound === 'true') return;
    const variants = parseVariants(card);
    if (!variants.length) return;

    card.dataset.roiVariantSyncBound = 'true';
    const scope = card.closest('.product-info') || card.closest('[data-section-id]') || document;
    const sync = () => syncCard(card, variants);
    const deferSync = () => schedule(sync);

    sync();
    scope.addEventListener('change', deferSync);
    scope.addEventListener('input', deferSync);
    document.addEventListener('variant:change', deferSync);
    document.addEventListener('product:variant-change', deferSync);
    window.addEventListener('popstate', deferSync);
    card.addEventListener('click', () => {
      const variantId = String(selectedVariantId(card));
      const variant = variants.find((item) => String(item.id) === variantId) || null;
      track('roi_card_opened', card, variant);
    });
  };

  const bindAll = () => document.querySelectorAll(CARD_SELECTOR).forEach(bindCard);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll, { once: true });
  } else {
    bindAll();
  }
})();
